// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3tohh","title":"Images90_title__1HBc7","images":"Images90_images__R_Wn2"};